import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LearnSaasComponent } from './learn-saas.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';

@NgModule({
  declarations: [
    LearnSaasComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule
  ],
  exports: [
    LearnSaasComponent
  ]
})
export class LearnSaasModule { }
